/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetDocumentQuestionAnswerResponse } from '../../models/get-document-question-answer-response';

export interface GetFaqs$Params {
  take?: number;
}

export function getFaqs(http: HttpClient, rootUrl: string, params?: GetFaqs$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GetDocumentQuestionAnswerResponse>>> {
  const rb = new RequestBuilder(rootUrl, getFaqs.PATH, 'get');
  if (params) {
    rb.query('take', params.take, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GetDocumentQuestionAnswerResponse>>;
    })
  );
}

getFaqs.PATH = '/api/documents/faq';
